import type { Degree, Distance, Point, SpatialRectangle } from "@pdfking/math"

import { GroupMatrix } from "./GroupMatrix"
import { MatrixBox } from "./MatrixBox"

/** The box `box` lands in, turned `rotation` counter-clockwise about `origin`
 * and moved by `translate`, through the same matrix a group carries. */
export const TurnBox = (
  box: SpatialRectangle<Distance>,
  rotation: Degree,
  origin: Point<Distance>,
  translate?: Point<Distance>
): SpatialRectangle<Distance> => MatrixBox(GroupMatrix({ origin, rotation, translate }), box)
